import React from 'react';

/**
 * GlassCard - The core building block of the Aurora Design System
 * 
 * @param {React.ReactNode} children - Content inside the card
 * @param {string} className - Additional classes
 * @param {string} gradient - Optional background gradient class (e.g., "from-blue-500/10 to-purple-500/10")
 * @param {Function} onClick - Optional click handler
 * @param {boolean} hoverEffect - Whether to show hover animations (default: true)
 */
const GlassCard = ({
    children,
    className = "",
    gradient = "",
    onClick,
    hoverEffect = true,
    ...props
}) => {
    return (
        <div
            onClick={onClick}
            className={`
        relative group overflow-hidden rounded-3xl 
        bg-white/5 backdrop-blur-xl border border-white/10 p-5 
        ${hoverEffect && onClick ? 'transition-all duration-300 hover:bg-white/10 hover:border-white/20 active:scale-95 cursor-pointer shadow-lg hover:shadow-xl' : ''}
        ${className}
      `}
            {...props}
        >
            {/* Optional Gradient Overlay */}
            {gradient && (
                <div className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-20 pointer-events-none group-hover:opacity-30 transition-opacity`} />
            )}

            {/* Internal Content */}
            <div className="relative z-10">
                {children}
            </div>

            {/* Decorative Shine Effect (Aurora Glow) */}
            {hoverEffect && (
                <div className="absolute inset-0 bg-gradient-to-t from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
            )}
        </div>
    );
};

export default GlassCard;
